import React from 'react';
import styled from 'styled-components';
import colors from 'config/colors';
import { Container } from 'reactstrap';
import Header from './components/Header';
import Footer from './components/Footer';

export default () => (
  <div>
    <Header />
    <Container id="features">
      <PolicySection>
        <PolicyHeading>
          Privacy Policy for Duty Managed Limited
        </PolicyHeading>
        <PolicyContent>
          <h3>Introduction</h3>
          <p>
          This Privacy Policy governs the use of your personal information by Duty
          Managed Limited (referred to in this Privacy Policy as &quot;we&quot;,
          &quot;us&quot;, &quot;our&quot; or &quot;Duty Managed&quot;).
          </p>

          <p>
          Our Privacy Policy explains what personal information we collect and how
          we collect, store use and retain that information, our use of cookies and
          similar technology, your rights to access personal information, and how you
          may contact us.
          </p>

          <p>
          We must comply with our obligations under the Privacy Act when dealing with
          your information. When we say “your information” in this Privacy Policy, we
          mean personal information as defined in and protected by the Privacy Act. Any
          personal information you provide to use will be stored, used and disclosed by
          us in accordance with this Privacy Policy.
          </p>

          <p>
          Your information will be collected and held by:
          Duty Managed Limited, Flat 4, 166 Williams Street, Cambridge, 3434, New Zealand.
          </p>

          <h3>
            Acceptance of this Privacy Policy
          </h3>

          <p>
          You accept this Privacy Policy, and authorise the collection, use, disclosure,
          storage and retention of your information by us as described in this Privacy
          Policy when you access or use the Service or otherwise provide us with any of
          your information.
          </p>

          <h3>
            What information we can collect about you
          </h3>

          <p>
          <i>
            We collect information you give us
          </i><br />
          When you create your Account and use our Service, we may collect information
          from you, including but not limited to your name, birth date, email, phone
          number, address, photo ID, payment information, tax details, account
          preferences, and any other information you provide to us.
          </p>

          <p>
          You are not required to provide us with your information. However, if you
          do not and we cannot otherwise collect your information, it may affect our
          ability to do business with you and perform the Service.
          </p>

          <p>
          <i>
            We collect information from third parties
          </i><br />
          We may collect information about you from third parties, for example from
          your employer providing information to us on your behalf or from service
          providers that help us to verify your identity, or make or receive payments
          from you, or to provide marketing services. We may also collect information
          about you from publicly available sources.
          </p>

          <p>
          We may use an electronic verification service (including a credit reference
          agency) to confirm your identity and the identity of anyone else providing
          or receiving money for you. By using the Service, you consent to this and
          confirm that you have the consent of any person providing or receiving money
          for you.
          </p>

          <h3>
            How we can use your information
          </h3>
          <p>
          We use your information in accordance with your specific instructions or
          consent, or in accordance with this Privacy Policy, including for the
          following purposes:
          </p>

          <p>
          <i>
          We can use your information to provide the Service
          </i><br />
          We use your information to provide, personalise, maintain, and improve
          our Service. For example, we may use your information to create and update
          your Account, verify your identity, process transactions and payments,
          or resolve operational problems.
          </p>

          <p>
          <i>
            We can use your information to comply with the law
          </i><br />
          We may use your information to detect, prevent, and protect against fraud
          and crime and to comply with the law.
          </p>

          <p>
          <i>
            We can use your information for customer support
          </i><br />
          We may use your information to communicate with you to provide and improve
          our customer support and resolve disputes.
          </p>

          <p>
          <i>
            We can use your information for marketing, research and development
          </i><br />
          We can use your information to test, research, analyse, and develop our
          Service to make it better, safer, and easier to use. We may use your information
          to obtain your feedback through a third party.  We may also use your information
          to market our Service, for example to send you news about our services or
          products or any other information we deem relevant or important to you.
          </p>

          <p>
          <i>
            Who we can share your information with
          </i><br />
          We may share your information with our service providers, subsidiaries,
          and business partners, such as:
          <ul>
            <li>third parties that help us to carry out the Service (including our
              hosting providers (if applicable) and payment processors to verify your
              identity, complete credit checks, or complete payments, for example);
            </li>
            <li>software-as-a-service providers that we use to provide the Service;</li>
            <li>cloud-storage providers;</li>
            <li>marketing partners;</li>
            <li>data analytics or research partners;</li>
            <li>third parties that help us to enhance the safety and security of the Service;</li>
            <li>third party providers for marketing purposes; </li>
            <li>our consultants, lawyers, accountants, insurers, and professional advisors;</li>
            <li>to any party which we notify you of at the time of collection;</li>
            <li>to any party with your consent or who we are permitted by applicable law to
            </li>disclose the information to.
          </ul>
          </p>

          <p>
          Some of the third parties referred to above may be located outside of New
          Zealand and may not be subject to New Zealand privacy laws. In that case,
          we will take such steps as are reasonable in the circumstances to confirm
          that those organisations are required to protect the information in a way
          that, overall, provides comparable safeguards to those under the Privacy Act.
          By using the Service and otherwise providing us with your information, you
          authorise such disclosure.
          </p>

          <p>
          We may also share your information if we sell to, or merge some or all of
          our business or assets with, another company.
          </p>

          <p>
          We may also use and share information that does not identify you for any purpose.
          </p>

          <h3>
            Website cookies and similar technology
          </h3>
          <p>
          Cookies and similar technology are used to remember your browser or device
          during and between website or app visits. Our Service may include cookies
          and other technology with a similar purpose. We can use this technology to
          do things, such as remember your preferences and settings, improve security,
          analyse traffic and trends, and measure the effectiveness and popularity of
          features or marketing.
          </p>

          <p>
          This technology is linked to your browser or device and usually it does
          not identify you. The sort of information collected includes your device
          type, date and time of use, referring website, IP address, and advertising
          identifiers. We may link this information to other information we collect
          about you.
          </p>

          <p>
          We may allow others to provide analytics, send messages and ads for us, and
          to track and report on performance. These entities may use cookies and similar
          technology to identify your browser or device when you use our Service, as
          well as when you visit other online sites and services.
          </p>

          <h3>
            Retaining your information
          </h3>
          <p>
          We will determine how long we will hold your personal information for the
          purposes set out in this Privacy Policy, except that we will not keep
          personal information for longer as is necessary to achieve the purpose
          for which we may lawfully use it.
          </p>

          <h3>
            We are committed to keeping your information safe and secure
          </h3>
          <p>
          We are committed to keeping your information safe and secure and will adopt
          such security safeguards as are reasonable in the circumstances to protect
          it against loss, misuse or any unauthorised access, use, modification or
          disclosure. However, despite our security measures, we cannot guarantee the
          security of the transmission or storage of your information.
          </p>

          <h3>
          Your rights regarding your information
          </h3>
          <p>
          You may:
          <ul>
            <li>
              withdraw any consents given in relation to the handling by us of your information;
            </li>
            <li>
              request access to your information; or
            </li>
            <li>
              request that we correct information that is inaccurate or out of date,
            </li>
          </ul>
          </p>

          <p>
          by contacting us using the details at the end of this Privacy Policy. We will
          take reasonable steps, consistent with our obligations under the Privacy Act,
          to correct or update that information if you so request.
          </p>

          <p>
          If at any time you no longer wish to receive marketing emails from us or our
          business partners, or do not want your information disclosed for direct
          marketing purposes, you can opt out using the function in any electronic marketing
          communications sent from us or our business partners or contact us by using
          the details at the end of this Privacy Policy.
          </p>

          <h3>
          Third-party links
          </h3>
          <p>
          Our Service may contain links to third-party websites. Our terms do not apply
          to any third-party websites. We take no responsibility for the content,
          operation, or privacy practices of other websites.
          </p>

          <h3>
          Changes to our Privacy Policy
          </h3>
          <p>
          This document sets out our current Privacy Policy, last updated 30 September
          2022. We may review this policy from time to time and will notify you of
          any changes by posting an updated version on our website or app.
          </p>

          <h3>
          Contact Us
          </h3>
          <p>
          If you have any questions regarding our Privacy Policy or wish to access
          or amend the information that we hold about you, please contact us at the
          following address:
          </p>

          <p>
          Attention: David Branch <br />
          Website: dutymanaged.co.nz <br />
          Email: admin@dutymanaged.co.nz <br />
          </p>

          <p>
          If you have concerns that we have not met our obligations to you as required
          by the Privacy Act and the Information Privacy Principles of that Act, you may
          contact us and make a complaint at the address and/or email listed above.
          </p>

          <p>
          More information about your rights and our obligations in respect to privacy
          and information on making a privacy complaint are available from the Office of
          the Privacy Commissioner at:
          </p>

          <p>
          Website: www.privacy.org.nz <br />
          Email: investigations@privacy.org.nz <br />
          </p>

          <h3>
          Interpretation
          </h3>
          <p>
          In this Privacy Policy:
          </p>

          <p>
            <b>Account</b> means your account with us that permits you to use our Service;<br />
            <b>Privacy Act</b> means the Privacy Act 2020 and any amendments or replacement
            legislation;<br />
            <b>Service</b> means the overall service we provide to you under our terms,
            includingyour access to and use of the Duty Managed website or app, operation
            of your Account, and any incidental and add-on services we provide to you.<br />
            <b>You</b> means the user of the Service.<br />
          </p>
        </PolicyContent>
      </PolicySection>
    </Container>
    <Footer />
  </div>
);

const PolicySection = styled.div`
  margin: auto;
  text-align: center;
  padding-top: 60px;

  img {
    pointer-events: none;
  }
`;

const PolicyHeading = styled.h3`
  color: ${colors.btnPrimary};
  margin-top: 90px;
  margin-bottom: 50px;
  font-size: 34px;
  line-height: 44px;
`;

const PolicyContent = styled.div`
  margin: auto;
  margin-bottom: 100px;
  text-align: left;

  h3 {
    font-size: 26px;
    line-height: 31px;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 26px;
  }
  ul {
    margin-top: 12px;
  }
`;
